import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export async function uploadFile(file, progressCallback = null) {
  if (!(file instanceof File)) {
    throw new Error('Parameter "file" is not a File.');
  }
  const formData = new FormData();
  formData.append('files', file);
  const xhr = new XMLHttpRequest();

  const result = await new Promise((resolve, reject) => {
    xhr.responseType = 'json';
    xhr.open('POST', `${publicRuntimeConfig.API_ENDPOINT}/api/upload`, true);
    /* xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) { // done
        return;
      }

      const response = new Response(xhr.response, {
        url: xhr.responseURL,
        status: xhr.status,
        statusText: xhr.statusText,
      });
    }; */
    xhr.onload = () => {
      resolve(xhr.response);
    };

    xhr.addEventListener('error', () => {
      reject(new TypeError('Failed to fetch'));
    });

    if (progressCallback) {
      xhr.addEventListener('progress', progressCallback);
    }

    xhr.send(formData);
  });

  /* const response = await fetch(
    `${publicRuntimeConfig.API_ENDPOINT}/api/upload`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.accessToken}`,
      },
      body: formData,
    },
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const result = await response.json();
  return result[0]; */

  return result[0];
}

export async function deleteFile(id) {
  const response = await fetch(
    `${publicRuntimeConfig.API_ENDPOINT}/api/upload/files/${id}`,
    {
      method: 'DELETE',
    },
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response.json();
}
